import { useInitData } from '../../../hooks'
import { getRequestProfilePathname } from '../../../utils/link'
import { BirdviewActivityRow } from '../BirdviewActivityRow'
import { BirdviewCard } from '../BirdviewCard'
import { BIRDVIEW_SECTION_TARGET } from '../DashboardBirdview.constants.targets'
import { useBirdviewListTarget } from '../DashboardBirdview.hooks'
import { checkIsBirdviewActivityDone } from '../DashboardBirdview.utils.rows'

function BirdviewActivitiesWidget({
  activityDoneById,
  dragHandleProps,
  pendingIds,
  section,
  title,
  onActivityToggle,
  onNavigate,
}) {
  const { getListTarget } = useBirdviewListTarget()

  const { availableSections } = useInitData()

  function handleShowAll() {
    onNavigate(getListTarget(BIRDVIEW_SECTION_TARGET.activities))
  }

  function handleOpen(item) {
    onNavigate(
      getRequestProfilePathname({ availableSections, id: item.requestId })
    )
  }

  return (
    <BirdviewCard
      count={section.total}
      dragHandleProps={dragHandleProps}
      hasMore={section.hasMore}
      isRefreshing={section.isRefreshing}
      skeletonProps={{ hasAction: false, hasBefore: true }}
      state={section.state}
      title={title}
      onRetry={section.reload}
      onShowAll={handleShowAll}
    >
      {section.items.map(item => (
        <BirdviewActivityRow
          isDone={checkIsBirdviewActivityDone(item, activityDoneById)}
          isPending={pendingIds.includes(item.id)}
          item={item}
          key={item.id}
          onOpen={handleOpen}
          onStatusToggle={onActivityToggle}
        />
      ))}
    </BirdviewCard>
  )
}

export default BirdviewActivitiesWidget
